import "core-js/modules/web.timers.js";
/*
 * debouncedresize: special jQuery event that happens once after a window resize
 *
 * latest version and complete README available on Github:
 * https://github.com/louisremi/jquery-smartresize
 *
 * Copyright 2012 @louis_remi
 * Licensed under the MIT license.
 *
 * This saved you an hour of work?
 * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
 */
(function ($) {
  var $event = $.event,
    $special,
    resizeTimeout;
  $special = $event.special.debouncedresize = {
    setup: function setup() {
      $(this).on("resize", $special.handler);
    },
    teardown: function teardown() {
      $(this).off("resize", $special.handler);
    },
    handler: function handler(event, execAsap) {
      // Save the context
      var context = this,
        args = arguments,
        dispatch = function dispatch() {
          // set correct event type
          event.type = "debouncedresize";
          $event.dispatch.apply(context, args);
        };
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      execAsap ? dispatch() : resizeTimeout = setTimeout(dispatch, $special.threshold);
    },
    threshold: 150
  };
})(jQuery);